// src/hooks/useRouteTracker.ts
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Fires a Google Analytics page_view on every navigation. Mounted in UserProvider, so it is scoped
// to authenticated routes only. PostHog pageviews are handled separately by usePostHogPageview
// (mounted globally via RootLayout) and cover unauthenticated routes too.
const useRouteTracker = (): void => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname + location.search;
    const gaId = import.meta.env.VITE_GA_MEASUREMENT_ID;
    if (gaId) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window as any).gtag?.('event', 'page_view', {
        page_path: path,
      });
    } else {
      console.error('Google Analytics Measurement ID is not defined');
    }
  }, [location]);
};

export default useRouteTracker;
